import styled from 'styled-components';

import { gridSizes, media, textSizes } from 'utils/style';

import ContactCard from 'components/ContactsList/ContactCard/component';

export default styled(ContactCard)`
  list-style: none;
  background-color: var(--white);
  padding: ${gridSizes('M')} 0px;
  border: 1px solid var(--grey300);
  border-left: none;
  border-right: none;
  border-top: none;
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  ${media.lessThan('extraSmall')`
    flex-direction: column;
    align-items: flex-start;
    padding: 16px;
  `};

  &.first {
    border-top: 1px solid var(--grey300);
  }
  &:hover {
    background-color: rgba(240, 242, 246, 0.5);
  }
  .companyInfo {
    color: var(--grey900);
    font-size: ${textSizes('L')};
  }
  .addressInfo,
  .contactInfo {
    font-size: ${textSizes('M')};
    color: var(--grey700);
  }
  p {
    margin: ${gridSizes('XS')};
  }

  .info {
    flex: 6;
  }

  .actions {
    flex: 4;
    align-items: flex-end;
    justify-content: flex-end;
    display: flex;

    button {
      background-color: #e0eaff;
      color: #002575;
      margin-right: 12px;
      .white {
        color: #002575;
        border: 1px solid #002575;
      }

      &:hover {
        background-color: #6797fe;
      }
    }

    button:last-child {
      margin-right: 0px;
    }
  }
`;
